
export enum DashEmsg {
    GOOGLE_DAI = 'urn:google:dai:2018'   
}    